
import { useState } from 'react';

const tiktokVideos = [
  {
    id: '7608338347194371350',
    title: 'Painting Transformation 🎨',
  },
  {
    id: '7608324095113055510',
    title: 'Behind the Scenes 🖌️',
  },
  {
    id: '7608322356867566870',
    title: 'Pro Techniques ✂️',
  },
  {
    id: '7344011608898751777',
    title: 'Room Reveal 🏠',
  },
  {
    id: '7344001109129743649',
    title: 'Colour Magic 🎭',
  },
];

function TikTokCard({ video }: { video: { id: string; title: string } }) {
  const [loaded, setLoaded] = useState(false);

  return (
    <div
      className="relative rounded-2xl overflow-hidden bg-gray-900 border border-white/10"
      style={{ aspectRatio: '9/16' }}
    >
      {!loaded && (
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-3 bg-gray-900">
          <div className="w-10 h-10 flex items-center justify-center">
            <i className="fab fa-tiktok text-white text-3xl"></i>
          </div>
          <p className="text-white/50 text-xs text-center px-2">{video.title}</p>
          <div className="w-6 h-6 border-2 border-white/20 border-t-white rounded-full animate-spin"></div>
        </div>
      )}
      <iframe
        src={`https://www.tiktok.com/embed/v2/${video.id}`}
        className="w-full h-full"
        style={{ border: 'none' }}
        allow="autoplay; encrypted-media"
        allowFullScreen
        onLoad={() => setLoaded(true)}
        title={video.title}
      />
    </div>
  );
}

export default function TikTokFeed() {
  return (
    <section className="py-24 px-6 bg-gray-950">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 text-white text-sm font-semibold px-4 py-2 rounded-full mb-4">
            <i className="fab fa-tiktok text-base"></i>
            <span>@brushour_</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Watch Us on{' '}
            <strong className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-amber-300">
              TikTok
            </strong>
          </h2>
          <p className="text-lg text-white/60 max-w-2xl mx-auto">
            Short-form painting transformations, tips, and behind-the-scenes moments. Follow along for daily inspiration.
          </p>
        </div>

        {/* Video Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
          {tiktokVideos.map((video) => (
            <TikTokCard key={video.id} video={video} />
          ))}
        </div>

        {/* Follow CTA */}
        <div className="text-center mt-12">
          <a
            href="https://www.tiktok.com/@brushour_"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-white text-gray-900 px-8 py-4 rounded-xl font-semibold hover:bg-orange-50 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-xl shadow-black/30 group"
          >
            <div className="w-6 h-6 flex items-center justify-center">
              <i className="fab fa-tiktok text-lg"></i>
            </div>
            <span>Follow @brushour_ on TikTok</span>
            <i className="ri-arrow-right-line text-lg group-hover:translate-x-1 transition-transform duration-300"></i>
          </a>
          <p className="text-white/40 text-sm mt-4">New videos every week — don't miss a transformation!</p>
        </div>
      </div>
    </section>
  );
}
